const productDescriptionAccordionOpeners = document.querySelectorAll('[data-block-type="description"] .accordion-item h2');

if (productDescriptionAccordionOpeners) {
  productDescriptionAccordionOpeners.forEach((opener) => {
    opener.addEventListener('click', function() {
      this.classList.toggle('open');
    });
  });
}

class DependableField extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form');
    this.inputField = this.querySelector('[data-input-field]');
    this.dependableFieldName = this.dataset.dependableFieldName;
    this.dependableFieldValue = this.dataset.dependableFieldValue;
    this.inputFieldInitiallyRequired = this.inputField.hasAttribute('required');
    

    if (this.form.querySelector(`[name="contact[${this.dependableFieldName}]"]`)) {
      if (this.inputFieldInitiallyRequired) {
        this.inputField.removeAttribute('required');
      }
      this.form.querySelectorAll(`[name="contact[${this.dependableFieldName}]"]`).forEach((input) => {
        input.addEventListener('change', this.handleInputChange.bind(this));
      })
    } else {
      this.removeAttribute('hidden');
    }
  }

  handleInputChange(event) {
    const {value} = event.target;
    if (value == this.dependableFieldValue) {
      this.removeAttribute('hidden');
      if (this.inputFieldInitiallyRequired) {
        this.inputField.setAttribute('required', 'required');
      }
    } else {
      this.setAttribute('hidden', 'hidden');
      if (this.inputFieldInitiallyRequired) {
        this.inputField.removeAttribute('required');
      }
    }
  }
}

customElements.define('dependable-field', DependableField);